import { Card, CardProps } from "@mui/material";

/**
 * @deprecated Replaced by SenecCard component
 */
export const BasicCard = (props: CardProps) => {
    return (
        <Card
            {...props}
            sx={{
                padding: "1.5rem",
                borderRadius: "12px",
                border: "1px solid",
                borderColor: "neutralGray20.main",
                boxShadow: "none",
                backgroundColor: "white.main",
                ...(props.sx ?? {}),
            }}
        >
            {props.children}
        </Card>
    );
};
